import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    totpToken: ''
  });
  
  const [requiresTOTP, setRequiresTOTP] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(
        formData.email,
        formData.password,
        requiresTOTP ? formData.totpToken : null
      );

      if (result.requiresTOTP) {
        setRequiresTOTP(true);
        setLoading(false);
        return;
      }

      if (result.success) {
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <h1 className="login-title">AzureUsage</h1>
          <p className="login-subtitle">Azure Storage Usage Dashboard</p>

          <form onSubmit={handleSubmit} className="login-form">
            {!requiresTOTP ? (
              <>
                <div className="form-group">
                  <label className="label" htmlFor="email">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="input"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    autoFocus
                  />
                </div>

                <div className="form-group">
                  <label className="label" htmlFor="password">
                    Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    className="input"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>
              </>
            ) : (
              <div className="form-group">
                <label className="label" htmlFor="totpToken">
                  Two-Factor Authentication Code
                </label>
                <input
                  type="text"
                  id="totpToken"
                  name="totpToken"
                  className="input totp-input"
                  value={formData.totpToken}
                  onChange={handleChange}
                  placeholder="000000"
                  maxLength="6"
                  required
                  autoFocus
                />
                <p className="totp-hint">
                  Enter the 6-digit code from your authenticator app
                </p>
              </div>
            )}

            {error && <div className="error">{error}</div>}

            <button
              type="submit"
              className="button button-primary login-button"
              disabled={loading}
            >
              {loading ? 'Logging in...' : requiresTOTP ? 'Verify' : 'Login'}
            </button>

            {requiresTOTP && (
              <button
                type="button"
                className="button button-secondary"
                onClick={() => {
                  setRequiresTOTP(false);
                  setFormData({ ...formData, totpToken: '' });
                }}
              >
                Back
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;

